import React, { useEffect } from 'react'
import ModalContainerSmall from '../ModalContainerSmall'
import { SocketState } from '../../../context/SocketProvider'
import { useDispatch, useSelector } from 'react-redux'
import { SET_1D_CLAIM_TICKET_ID, SET_1D_CLAIM_TICKET_RECORD, Select1dClaimTicket, Select1dClaimTicketRecord } from '../../../redux/1d-slice/gameInfo1dSlice'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import moment from 'moment'

function ClaimTicketModal2d() {
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const claimTicketRecord = useSelector(Select1dClaimTicketRecord)
  // console.log('claimTicketRecord: ', claimTicketRecord);
  const ticketID = useSelector(Select1dClaimTicket)

  useEffect(() => {
    if (ticketID.length >= 10) {
      claimTicket()
    }

  }, [ticketID])

  useEffect(() => {
    return () => {
      dispatch(SET_1D_CLAIM_TICKET_RECORD({}))
      dispatch(SET_1D_CLAIM_TICKET_ID(''))
    }
  }, [])




  let claimTicket = () => {
    dispatch(SET_MAIN_LOADER(true))
    var data = {
      "en": "TWO_CHANCE_TICKET_CLAIM",
      "data": {
        "ticket_id": ticketID,
      }
    }
    socket.emit("req", data);
    dispatch(SET_1D_CLAIM_TICKET_ID(''))
    // setTicketId('')

  }

  return (
    <ModalContainerSmall title={'Claim Ticket'} navigation={'/1d'} >
      <div className='w-full'>
        <div className='flex p-4'>
          <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Ticket No</p></div>
          <div className='w-1/2'> <input
            className="shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            value={ticketID}
            autoFocus={true}
            onChange={(e) => dispatch(SET_1D_CLAIM_TICKET_ID(e.target.value))}
          /></div>
        </div>
        {/*  */}
        {claimTicketRecord.err ?
          <div className='flex flex-1 justify-center items-center pt-16 flex-col'>
            <p className='font-bold text-[20px] mb-20'>Ticket Id : {claimTicketRecord?.data.ticket_id}</p>
            <p className='font-bold text-[18px]'>{claimTicketRecord.msg}</p>
          </div>
          :
          <>
            <div className='flex p-4'>
              <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Draw Date Time</p></div>
              <div className='w-1/2'><p className='font-semibold text-[18px]'>{claimTicketRecord?.data?.deal_date} {claimTicketRecord?.data?.deal_time}</p> </div>
            </div>
            {/*  */}
            <div className='flex p-4'>
              <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Claim Date Time</p></div>
              <div className='w-1/2'><p className='font-semibold text-[18px]'>{claimTicketRecord?.deal_date ? moment().format('DD-MM-yyyy hh:mm:ss A') : ''}</p> </div>
            </div>
            {/*  */}
            <div className='flex p-4 justify-center'>
              {claimTicketRecord?.data?.msg &&
                <p className='font-semibold text-[18px] text-green-600'>
                  {claimTicketRecord?.data?.msg}
                </p>}
              {/* <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Win No</p></div>
                    <div className='w-1/2'> </div> */}
            </div>
          </>
        }


      </div>
    </ModalContainerSmall>
  )
}

export default ClaimTicketModal2d


// 66TT7BZVS9

// F27U8KDES8

// {
//   "_id": "64a4bdbc886e339ff9b38c8e",
//   "game_id": "23070500004",
//   "user_name": "70001",
//   "game_type": "mini_lottery_game",
//   "ticket_id": "F27U8KDES8",
//   "start_point": 2099,
//   "total_bet_amount": 1,
//   "total_win_amount": 9,
//   "x_reward_amount": 0,
//   "commission_amount": 0,
//   "total_end_amount": 0,
//   "draw_time": "2023-07-05T00:59:55.669Z",
//   "advance_timer": "2023-07-04T09:15:58.427Z",
//   "is_advance": false,
//   "status": 3,
//   "deal_time": "06:15:00 AM",
//   "deal_date": "05/07/2023",
//   "time_stamps": "05/07/2023, 06:17:56 AM",
//   "user_id": "649d2171961b0000db000cf6",
//   "card_details": {
//       "1045": 1
//   },
//   "commission_info": true,
//   "createdAt": "2023-07-05T00:47:56.672Z",
//   "updatedAt": "2023-07-05T01:27:50.071Z",
//   "__v": 0,
//   "result_card": {
//       "0": {
//           "1": "1045",
//           "3": "3026",
//           "5": "5053"
//       },
//       "1": {
//           "1": "1142",
//           "3": "3117",
//           "5": "5174"
//       },
//       "2": {
//           "1": "1211",
//           "3": "3233",
//           "5": "5238"
//       },
//       "3": {
//           "1": "1397",
//           "3": "3315",
//           "5": "5386"
//       },
//       "4": {
//           "1": "1498",
//           "3": "3404",
//           "5": "5481"
//       },
//       "5": {
//           "1": "1510",
//           "3": "3542",
//           "5": "5519"
//       },
//       "6": {
//           "1": "1614",
//           "3": "3649",
//           "5": "5680"
//       },
//       "7": {
//           "1": "1786",
//           "3": "3770",
//           "5": "5732"
//       },
//       "8": {
//           "1": "1849",
//           "3": "3841",
//           "5": "5847"
//       },
//       "9": {
//           "1": "1933",
//           "3": "3908",
//           "5": "5985"
//       }
//   },
//   "in_game": true,
//   "take": false,
//   "last_win_cards": [
//       {
//           "0": {
//               "1": "1070",
//               "3": "3070",
//               "5": "5021"
//           },
//           "1": {
//               "1": "1192",
//               "3": "3161",
//               "5": "5128"
//           },
//           "2": {
//               "1": "1294",
//               "3": "3262",
//               "5": "5239"
//           },
//           "3": {
//               "1": "1338",
//               "3": "3356",
//               "5": "5345"
//           },
//           "4": {
//               "1": "1467",
//               "3": "3484",
//               "5": "5487"
//           },
//           "5": {
//               "1": "1501",
//               "3": "3525",
//               "5": "5562"
//           },
//           "6": {
//               "1": "1605",
//               "3": "3689",
//               "5": "5606"
//           },
//           "7": {
//               "1": "1746",
//               "3": "3793",
//               "5": "5764"
//           },
//           "8": {
//               "1": "1803",
//               "3": "3818",
//               "5": "5883"
//           },
//           "9": {
//               "1": "1989",
//               "3": "3907",
//               "5": "5920"
//           }
//       },
//       {
//           "0": {
//               "1": "1045",
//               "3": "3026",
//               "5": "5053"
//           },
//           "1": {
//               "1": "1142",
//               "3": "3117",
//               "5": "5174"
//           },
//           "2": {
//               "1": "1211",
//               "3": "3233",
//               "5": "5238"
//           },
//           "3": {
//               "1": "1397",
//               "3": "3315",
//               "5": "5386"
//           },
//           "4": {
//               "1": "1498",
//               "3": "3404",
//               "5": "5481"
//           },
//           "5": {
//               "1": "1510",
//               "3": "3542",
//               "5": "5519"
//           },
//           "6": {
//               "1": "1614",
//               "3": "3649",
//               "5": "5680"
//           },
//           "7": {
//               "1": "1786",
//               "3": "3770",
//               "5": "5732"
//           },
//           "8": {
//               "1": "1849",
//               "3": "3841",
//               "5": "5847"
//           },
//           "9": {
//               "1": "1933",
//               "3": "3908",
//               "5": "5985"
//           }
//       },
//       {
//           "0": {
//               "1": "1075",
//               "3": "3040",
//               "5": "5000"
//           },
//           "1": {
//               "1": "1173",
//               "3": "3104",
//               "5": "5174"
//           },
//           "2": {
//               "1": "1287",
//               "3": "3297",
//               "5": "5238"
//           },
//           "3": {
//               "1": "1399",
//               "3": "3329",
//               "5": "5313"
//           },
//           "4": {
//               "1": "1404",
//               "3": "3461",
//               "5": "5449"
//           },
//           "5": {
//               "1": "1596",
//               "3": "3562",
//               "5": "5587"
//           },
//           "6": {
//               "1": "1611",
//               "3": "3663",
//               "5": "5692"
//           },
//           "7": {
//               "1": "1730",
//               "3": "3735",
//               "5": "5765"
//           },
//           "8": {
//               "1": "1828",
//               "3": "3816",
//               "5": "5826"
//           },
//           "9": {
//               "1": "1972",
//               "3": "3978",
//               "5": "5961"
//           }
//       }
//   ],
//   "msg": "You claim Rs.9 Amount and Ticket is : F27U8KDES8."
// }